module.exports = __webpack_public_path__ + "static/media/ban2.21cf995d.jpg";